import React, { FunctionComponent } from 'react';
import { Alert } from 'antd';
import classNames from 'classnames';
import styles from './FlashMessage.module.scss';

interface IProps {
  description?: string | React.ReactNode;
  message?: string | React.ReactNode;
  closable: boolean;
  onClose?: any;
  type: 'success' | 'error' | 'warning' | 'info' | 'danger'; // TODO: add icons, colors to variables.less, and text colors to atnd.scss for warning, info, and error
}

const FlashMessage: FunctionComponent<IProps> = ({
  description = null,
  message,
  type,
  closable = true,
  onClose = null,
}) => {
  let icon;
  let transformedType = type;

  if (transformedType === 'danger') {
    transformedType = 'error';
  }

  return (
    <Alert
      className={classNames(styles[`${transformedType}Type`])}
      description={description}
      message={message}
      type={transformedType}
      showIcon={!!icon}
      icon={icon}
      closable={closable}
      onClose={onClose}
    />
  );
};

export default FlashMessage;
